import { useRouteLoaderData } from "react-router";
import { getTilsynsErklaering } from "../../api/tilsynserklaering";
import Intro from "../../components/tilsynserklaering/Intro";
import TilsynserklaeringForm from "../../components/tilsynserklaering/TilsynerklaeringForm";
import { redirectToLogin } from "../../routerUtil";
import { TILSYN_FORM_INITIAL_VALUES } from "../../constants/tilsyn/initialValues";
import { TilsynserklaeringMetadata } from "../../interfaces/tilsynserklaering";
import { ROUTES } from "../../constants/routes";
import { reviver } from "../../util/json";
import { getStamdataPerson } from "../../api/stamdata";
import { fuldtNavn } from "../../lib/stamdataNavn";

export type TEByIdLoaderData = Exclude<
  Awaited<ReturnType<typeof tilsynsErklaeringIdLoader>>,
  Response
>;

export const tilsynsErklaeringIdLoader = async ({ params }) => {
  const { id } = params;
  try {
    const tilsynerklaeringPromise = getTilsynsErklaering(id);
    const [te] = await Promise.all([tilsynerklaeringPromise]);
    const metadata: TilsynserklaeringMetadata = {
      senestGemt: te.sidstAendret,
      erklaeringAar: te.erklaeringAar,
      fristDato: te.frist,
      person: {
        navn: "ukendt person",
      },
    };
    if (te.personId) {
      const person = await getStamdataPerson(te.personId);
      // Før ADV-288 var dette en ren konkatenering, og et medlem uden Person-række i portalen
      // (ADV-272) fik derfor navnet "null null": serveren svarer 200 med et tomt PersonModel, som
      // getStamdataPerson nu oversætter til null. Kan navnet ikke dannes, bliver standardnavnet
      // ovenfor stående.
      const navn = fuldtNavn(person);
      if (navn) {
        metadata.person = { navn };
      }
    }
    return { te, metadata };
  } catch (error) {
    console.error(error);
    return redirectToLogin();
  }
};

export default function TilsynsErklaeringId() {
  const { te, metadata } = useRouteLoaderData(
    ROUTES.tilsynForm.id,
  ) as TEByIdLoaderData;
  const jsonData = te.jsonData;
  const check = !!jsonData && jsonData !== "null";
  const formValues = check
    ? JSON.parse(jsonData, reviver)["form"]
    : TILSYN_FORM_INITIAL_VALUES;

  return (
    <>
      <Intro />
      <TilsynserklaeringForm
        id={te.id}
        initialValues={formValues ? formValues : TILSYN_FORM_INITIAL_VALUES}
        metaData={metadata}
        loginToken={te.loginToken}
      />
    </>
  );
}
